module.exports = __webpack_public_path__ + "assets/media/morning.78b6622e.mp3";